// extracted by mini-css-extract-plugin
export default {"container":"main-scene_container__Wqxlk","scroll_down":"main-scene_scroll_down__WZZcn"};